var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuoteStart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.539615,
    d: "M24.0384 -0.00418204L24.0566 4.31805C22.0959 4.7083 20.7256 5.51227 19.9458 6.72998C19.166 7.94768 18.7826 10.111 18.7957 13.22L23.7996 13.1917L23.8451 23.9973L14.2297 24.0517L14.1914 14.9522C14.1716 10.2509 14.9085 6.60682 16.4021 4.02013C17.8954 1.35761 20.4408 0.0161744 24.0384 -0.00418204ZM9.90971 0.0757632L9.92791 4.398C7.96719 4.78824 6.59692 5.59222 5.8171 6.80992C5.03728 8.02762 4.65391 10.191 4.667 13.2999L9.67092 13.2716L9.71641 24.0772L0.101048 24.1316L0.0627359 15.0322C0.0429414 10.3308 0.779839 6.68676 2.27343 4.10007C3.7667 1.43756 6.31213 0.0961197 9.90971 0.0757632Z",
    fill: "#6BCF7F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuoteStart);
export default __webpack_public_path__ + "static/media/quote-start.e872225c781a382ba0c4f0dda5317a35.svg";
export { ForwardRef as ReactComponent };